export class OrganizationFilters {
  name: string;
  orgCode: string;
  description: string;
  localities: string[];
  states: string[];
  countries: string[];
  organizationTypesUuids: string;
  parentUuid: string;
}
